export function initializePersonalProperty(type) {
    return {
        type,
        initialCategorySlug: null,
        category: null,
    };
}
